import { formatObject, generateUserData } from '../utils';

export const initAppsflyerUserData = async (user) => {
  const userData = generateUserData(user, {
    separateSensitiveData: true,
  });

  if (window?.AF) {
    await window.AF(
      'pba',
      'setCustomerUserId',
      userData?.sensitiveData.account_user_id
    );
  }
};

const filterUserProperties = (userData) => {
  const sensitiveDataKeys = [
    'account_email',
    'account_id',
    'account_name',
    'account_user_id',
    'device_uuid',
    'profile_account_id',
    'profile_id',
    'profile_name',
    'user_id',
  ];
  const data = {};

  for (let key in userData) {
    if (sensitiveDataKeys?.includes(key)) continue;
    else data[key] = userData[key];
  }

  return data;
};

const trackAppsFlyer = (event, options = { params: {}, user: null }) => {
  const { params = {}, user = null } = options;
  const userData = generateUserData(user, { separateSensitiveData: true });
  const time = new Date().getTime();

  const property = formatObject(params);
  const filteredData = filterUserProperties(property);

  let payload = {
    ...filteredData,
    time,
  };

  let maxLength = 1000;
  let payloadHandler =
    payload.length > maxLength
      ? { message: 'data is more than 1000 chars' }
      : payload;

  window.AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: event,
    eventValue: payloadHandler,
  });
};

export default trackAppsFlyer;
